<template>
  <div class="modal fade" :id="modalId" tabindex="-1" :aria-labelledby="modalId + 'Label'" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content" style="width: 100%">
        <div class="modal-header">
          <h5 class="modal-title fs-5 " :id="modalId + 'Label'">{{ title }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <BaseFormPreview :formType="formType" />
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseFormPreview from './BaseFormPreview.vue';

export default {
  name: 'PreviewModal',
  components: {
    BaseFormPreview
  },
  props: {
    formType: {
      type: String,
      default: ''
    },
    modalId: {
      type: String,
      default: 'previewModal'
    },
    title: {
      type: String,
      default: 'VISTA PREVIA DEL FORMULARIO BASE'
    }
  }
}
</script>

<style scoped>

</style>